import { render, staticRenderFns } from "./AddAreaForm.vue?vue&type=template&id=2fc2e82c"
import script from "./AddAreaForm.vue?vue&type=script&lang=js"
export * from "./AddAreaForm.vue?vue&type=script&lang=js"
import style0 from "./AddAreaForm.vue?vue&type=style&index=0&id=2fc2e82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports